function isArray(obj) {
    return !!obj && obj.constructor === Array;
}

function isObject(obj) {
    return typeof obj === 'object' && obj !== null
}


export function returnDataArrayObject(resObj, availableFields) {
    let data = [];
    if (isObject(resObj)) {

        if (isArray(resObj)) {
            // let formattedData  = resObj.map(ro => {})

            return { data: resObj }
        } else {
            const fieldNames = Object.keys(resObj)
            fieldNames.forEach(nm => {
                if (isArray(resObj[nm])) {
                    data = [...data, ...resObj[nm]];
                    return;
                }
            })

            return (
                { data: data }
            )
        }

    }

    // Always hand back the same shape. Callers read `.data` straight off the result,
    // so returning undefined here (which happened whenever an API replied with text
    // instead of JSON — a proxy error page, an HTML login redirect) threw
    // "Cannot read property 'data' of undefined" and took the whole app down.
    return { data: [] }

}